// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .cdk-overlay-pane {
  max-width: 90vw !important;
}
::ng-deep .cdk-overlay-pane .mat-mdc-dialog-container {
  border-radius: 16px !important;
  overflow: hidden !important;
  padding: 0 !important;
}
::ng-deep .cdk-overlay-pane .mdc-dialog__container {
  border-radius: 16px !important;
  overflow: hidden !important;
}
::ng-deep .cdk-overlay-pane .mdc-dialog__surface {
  border-radius: 16px !important;
  overflow: hidden !important;
  padding: 0 !important;
}

.message-dialog-container {
  display: flex;
  flex-direction: column;
  min-width: 360px;
  max-width: 480px;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}
@media (max-width: 480px) {
  .message-dialog-container {
    min-width: unset;
    width: 100%;
  }
}

.message-dialog-header {
  cursor: move;
}
.message-dialog-header .message-dialog-header-left {
  position: relative;
  z-index: 1;
  min-width: 0;
}
.message-dialog-header .header-close-btn {
  width: 30px !important;
  height: 30px !important;
  line-height: 30px !important;
  min-width: unset !important;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.75);
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px !important;
  transition: background 0.15s, color 0.15s;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  position: relative;
  z-index: 1;
}
.message-dialog-header .header-close-btn ::ng-deep .mat-mdc-button-touch-target {
  width: 30px !important;
  height: 30px !important;
}
.message-dialog-header .header-close-btn mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  line-height: 17px;
}
.message-dialog-header .header-close-btn:hover {
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

.message-dialog-body {
  padding: 28px 28px 8px;
  background: #ffffff;
}

.message-dialog-content {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 16px !important;
  padding: 0 !important;
  max-height: unset !important;
  overflow: visible !important;
}

.info-icon-wrap {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background: #e8f0fe;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  animation: popIn 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;
}
.info-icon-wrap .info-icon {
  font-size: 36px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  color: #1a56db;
}

.message-text {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
  color: #1e293b;
  line-height: 1.6;
  text-align: center;
  animation: fadeUp 0.3s ease 0.1s both;
}

.message-dialog-actions {
  display: flex !important;
  justify-content: center !important;
  padding: 20px 28px 24px !important;
  background: #ffffff;
  gap: 10px;
}
.message-dialog-actions .ok-btn {
  min-width: 130px;
  height: 40px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px;
  box-shadow: 0 4px 14px rgba(26, 86, 219, 0.3);
  transition: box-shadow 0.2s, transform 0.15s;
}
.message-dialog-actions .ok-btn mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  line-height: 17px;
}
.message-dialog-actions .ok-btn:hover {
  box-shadow: 0 6px 20px rgba(26, 86, 219, 0.4);
  transform: translateY(-1px);
}
.message-dialog-actions .ok-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(26, 86, 219, 0.25);
}

@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.6);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared-component/message-dialog/message-dialog.component.scss"],"names":[],"mappings":"AAeA;EACI,0BAAA;AAdJ;AAgBI;EACI,8BAAA;EACA,2BAAA;EACA,qBAAA;AAdR;AAiBI;EACI,8BAAA;EACA,2BAAA;AAfR;AAkBI;EACI,8BAAA;EACA,2BAAA;EACA,qBAAA;AAhBR;;AAqBA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBApCM;EAqCN,mBAhCK;EAiCL,gBAAA;EACA,2CAAA;AAlBJ;AAoBI;EAVJ;IAWQ,gBAAA;IACA,WAAA;EAjBN;AACF;;AAqBA;EACI,YAAA;AAlBJ;AAoBI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AAlBR;AAqBI;EACI,sBAAA;EACA,uBAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,gCAAA;EACA,oCAAA;EACA,6BAAA;EACA,yCAAA;EACA,qBAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,kBAAA;EACA,UAAA;AAnBR;AAqBQ;EACI,sBAAA;EACA,uBAAA;AAnBZ;AAsBQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AApBZ;AAuBQ;EACI,qCAAA;EACA,WAAA;AArBZ;;AA2BA;EACI,sBAAA;EACA,mBAhGM;AAwEV;;AA2BA;EACI,wBAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,4BAAA;AAxBJ;;AA4BA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAnHY;EAoHZ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kEAAA;AAzBJ;AA2BI;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAhIE;AAuGV;;AA8BA;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cApIG;EAqIH,gBAAA;EACA,kBAAA;EACA,qCAAA;AA3BJ;;AA+BA;EACI,wBAAA;EACA,kCAAA;EACA,kCAAA;EACA,mBAlJM;EAmJN,SAAA;AA5BJ;AA8BI;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,6BAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,QAAA;EACA,6CAAA;EACA,4CAAA;AA5BR;AA8BQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA5BZ;AA+BQ;EACI,6CAAA;EACA,2BAAA;AA7BZ;AAgCQ;EACI,wBAAA;EACA,6CAAA;AA9BZ;;AAoCA;EACI;IACI,UAAA;IACA,qBAAA;EAjCN;EAoCE;IACI,UAAA;IACA,mBAAA;EAlCN;AACF;AAqCA;EACI;IACI,UAAA;IACA,0BAAA;EAnCN;EAsCE;IACI,UAAA;IACA,wBAAA;EApCN;AACF","sourcesContent":["// ==========================================================================\r\n// Component: Message-dialog.component\r\n// ==========================================================================\r\n\r\n$primary: #1a56db;\r\n$primary-light: #e8f0fe;\r\n$surface: #ffffff;\r\n$bg: #f4f6fb;\r\n$border: #e2e8f0;\r\n$text: #1e293b;\r\n$text-muted: #64748b;\r\n$radius: 16px;\r\n$radius-sm: 8px;\r\n\r\n// ── Global overlay fix ────────────────────────\r\n::ng-deep .cdk-overlay-pane {\r\n    max-width: 90vw !important;\r\n\r\n    .mat-mdc-dialog-container {\r\n        border-radius: $radius !important;\r\n        overflow: hidden !important;\r\n        padding: 0 !important;\r\n    }\r\n\r\n    .mdc-dialog__container {\r\n        border-radius: $radius !important;\r\n        overflow: hidden !important;\r\n    }\r\n\r\n    .mdc-dialog__surface {\r\n        border-radius: $radius !important;\r\n        overflow: hidden !important;\r\n        padding: 0 !important;\r\n    }\r\n}\r\n\r\n// ── Container ─────────────────────────────────\r\n.message-dialog-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    min-width: 360px;\r\n    max-width: 480px;\r\n    background: $surface;\r\n    border-radius: $radius;\r\n    overflow: hidden;\r\n    box-shadow: 0 20px 60px rgba(0, 0, 0, .15);\r\n\r\n    @media (max-width: 480px) {\r\n        min-width: unset;\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n// ── Header ────────────────────────────────────\r\n.message-dialog-header {\n    cursor: move;\n\n    .message-dialog-header-left {\n        position: relative;\n        z-index: 1;\n        min-width: 0;\n    }\n\n    .header-close-btn {\n        width: 30px !important;\n        height: 30px !important;\r\n        line-height: 30px !important;\r\n        min-width: unset !important;\r\n        flex-shrink: 0;\r\n        color: rgba(255, 255, 255, 0.75);\r\n        background: rgba(255, 255, 255, 0.1);\r\n        border-radius: 8px !important;\r\n        transition: background .15s, color .15s;\r\n        padding: 0 !important;\n        display: flex !important;\n        align-items: center !important;\n        justify-content: center !important;\n        position: relative;\n        z-index: 1;\n\n        ::ng-deep .mat-mdc-button-touch-target {\n            width: 30px !important;\n            height: 30px !important;\r\n        }\r\n\r\n        mat-icon {\r\n            font-size: 17px;\r\n            width: 17px;\r\n            height: 17px;\r\n            line-height: 17px;\r\n        }\r\n\r\n        &:hover {\r\n            background: rgba(255, 255, 255, 0.22);\r\n            color: #fff;\r\n        }\r\n    }\r\n}\r\n\r\n// ── Body ──────────────────────────────────────\r\n.message-dialog-body {\r\n    padding: 28px 28px 8px;\r\n    background: $surface;\r\n}\r\n\r\n.message-dialog-content {\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    align-items: center !important;\r\n    gap: 16px !important;\r\n    padding: 0 !important;\r\n    max-height: unset !important;\r\n    overflow: visible !important;\r\n}\r\n\r\n// ── Info icon ─────────────────────────────────\r\n.info-icon-wrap {\r\n    width: 68px;\r\n    height: 68px;\r\n    border-radius: 50%;\r\n    background: $primary-light;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n    animation: popIn .4s cubic-bezier(0.175, 0.885, 0.32, 1.275) both;\r\n\r\n    .info-icon {\r\n        font-size: 36px;\r\n        width: 36px;\r\n        height: 36px;\r\n        line-height: 36px;\r\n        color: $primary;\r\n    }\r\n}\r\n\r\n// ── Message text ──────────────────────────────\r\n.message-text {\r\n    margin: 0;\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n    color: $text;\r\n    line-height: 1.6;\r\n    text-align: center;\r\n    animation: fadeUp .3s ease .1s both;\r\n}\r\n\r\n// ── Actions ───────────────────────────────────\r\n.message-dialog-actions {\r\n    display: flex !important;\r\n    justify-content: center !important;\r\n    padding: 20px 28px 24px !important;\r\n    background: $surface;\r\n    gap: 10px;\r\n\r\n    .ok-btn {\r\n        min-width: 130px;\r\n        height: 40px;\r\n        font-size: 13px;\r\n        font-weight: 600;\r\n        letter-spacing: .04em;\r\n        border-radius: $radius-sm !important;\r\n        display: flex !important;\r\n        align-items: center !important;\r\n        justify-content: center !important;\r\n        gap: 6px;\r\n        box-shadow: 0 4px 14px rgba(26, 86, 219, .3);\r\n        transition: box-shadow .2s, transform .15s;\r\n\r\n        mat-icon {\r\n            font-size: 17px;\r\n            width: 17px;\r\n            height: 17px;\r\n            line-height: 17px;\r\n        }\r\n\r\n        &:hover {\r\n            box-shadow: 0 6px 20px rgba(26, 86, 219, .4);\r\n            transform: translateY(-1px);\r\n        }\r\n\r\n        &:active {\r\n            transform: translateY(0);\r\n            box-shadow: 0 2px 8px rgba(26, 86, 219, .25);\r\n        }\r\n    }\r\n}\r\n\r\n// ── Animations ────────────────────────────────\r\n@keyframes popIn {\r\n    from {\r\n        opacity: 0;\r\n        transform: scale(0.6);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n@keyframes fadeUp {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(8px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
